export const canUseSoundApp = (user) => {
  if (user.subscriptionStatus !== "active") return false;
  return true;
};

export const canUseStreamApp = (user) => {
  return user.subscriptionStatus === "active";

};
